module.exports = __webpack_public_path__ + "static/media/copy.0207bd86.svg";